(() => {
  const encodeHref = (phone, message) => `https://wa.me/${String(phone || '').replace(/\D/g, '')}?text=${encodeURIComponent(String(message || ''))}`;
  const productMessage = ({ name, sku, variantSku, variant, url, quantity, branding, quoteRequired }) => {
    const lines = ['Hi Usha Printings, please share options and a quote.'];
    if (name) lines.push(`Gift: ${name}`);
    if (sku) lines.push(`SKU: ${sku}`);
    if (variantSku && variantSku !== sku) lines.push(`Variant SKU: ${variantSku}`);
    if (variant && variant !== 'Default Title') lines.push(`Variant: ${variant}`);
    if (url) lines.push(`Product: ${url}`);
    if (Number.isInteger(Number(quantity)) && Number(quantity) > 0) lines.push(`Requested quantity: ${Number(quantity)}`);
    if (branding) lines.push(`Branding: ${branding}`);
    if (quoteRequired) lines.push('Pricing: Please quote for this requested quantity.');
    return lines.join('\n');
  };
  const shortlistMessage = ({ budget, quantity, recipient, products = [] }) => {
    const lines = ['Hi Usha Printings, please help me choose corporate Diwali gifts.'];
    if (Number.isInteger(Number(quantity)) && Number(quantity) > 0) lines.push(`Requested quantity: ${Number(quantity)} pieces`);
    if (budget) lines.push(`Budget per gift: ${budget}`);
    if (recipient) lines.push(`Recipient: ${recipient}`);
    const selected = products.filter(item => item && (item.sku || item.name)).slice(0, 3);
    if (selected.length) {
      lines.push('Interested in:');
      selected.forEach(item => {
        const detail = [item.sku, item.name].filter(Boolean).join(' — ');
        lines.push(item.url ? `${detail} (${item.url})` : detail);
      });
    }
    lines.push('Please share suitable options, branding details and a quote.');
    return lines.join('\n');
  };
  window.UshaWhatsApp = Object.freeze({ encodeHref, productMessage, shortlistMessage });
})();
